export enum FLAG_KEYS {
  ELLA_CHAT = 'ella-chat',
  ELLA_COMPLETE_THE_LOOK = 'ella-complete-the-look',
  APP_BANNER = 'app-banner',
  FLAG_ELLA_FEEDBACK = 'FLAG_ELLA_FEEDBACK',
  MORGAN_STEWART_NAVBAR = 'morgan-stewart-navbar',
  PRIVEE = 'privee',
  PRIVEE_CHARGE_INITIATION_FEE = 'privee-charge-initiation-fee',
  PRIVEE_VIP_INSURANCE = 'privee-vip-insurance',
  WAITLIST_TO_UPGRADE = 'waitlist-to-upgrade',
  APPLY_PROMO_CODE = 'apply-promo-code',
  CARD_AUTHORIZATION = 'card-authorization',
  COMPLEX_WISHLIST = 'complex-wishlist',
  PDP_WEB_ELIGIBLE_AVAILABILITY = 'pdp-web-eligible-availability',
  SINGLE_PAGE_APPLICATION = 'single-page-application',
  CHECKOUT_WEB_ELIGIBLE_ENFORCEMENT = 'checkout-web-eligible-enforcement',
  PROSPERSTACK_CANCELLATION = 'prosperstack-cancellation',
  BRAND_AMBASSADOR_REDIRECT_MODAL = 'brand-ambassador-redirect-modal',
  APPLY_SINGLE_PAGE = 'apply-single-page',
  API_AUTH_ENFORCEMENT = 'api-auth-enforcement',
  BOTID_RATE_LIMIT_ENFORCEMENT = 'botid-rate-limit-enforcement',
  ADDRESS_ENDPOINT_MIGRATION = 'address-endpoint-migration',
  MEMBER_SESSION = 'member-session',
  MEMBER_PASSWORD_MIGRATION = 'member-password-migration'
}

/** @deprecated
 *
 * These should be deprecated as the flag mechanism will not always be managed via env var.
 * Until then, make sure to add checks for any new feature flags and remove old ones.
 */
export const datadogFeatureFlags = {
  'ella-chat': process.env.FLAG_ELLA_CHAT === 'true',
  'ella-complete-the-look': process.env.FLAG_ELLA_COMPLETE_THE_LOOK === 'true',
  'app-banner': process.env.APP_BANNER === 'true',
  'ella-feedback': process.env.FLAG_ELLA_FEEDBACK === 'true'
};
